module.exports = __webpack_public_path__ + "img/Element_extraction-2.2008a38e.png";